<template>
	<PageTemplate>
		<template slot="title">
			Contact Info
		</template>
		<template slot="content">
			<img src="img/about.jpg" class="lab-photo">
			<h2>Address</h2>
			<p>
				Faulkner Nanoscience and<br>Technology (FNT)
				<br>
				B.107
				<br>
				102 E. 24th St.
				<br>
				Austin, TX 78712
			</p>
			
			<h2>Office Hours</h2>
			<p>
				8:00 a.m. - 5:00 p.m., Monday - Friday
			</p>
			
			<h2> Location</h2>
			<div class="gmapwrap">
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.217834178122!2d-97.740175385275!3d30.28785968179447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644b583320fec05%3A0xd1fe0579285357b0!2s102+E+24th+St%2C+Austin%2C+TX+78712!5e0!3m2!1sen!2sus!4v1535761106273" class="gmapsize" frameborder="0"  allowfullscreen></iframe>
			</div>
		</template>
	</PageTemplate>
</template>

<script>
import PageTemplate from './PageTemplate'
export default {
  name: 'contactinfo',
  data () {
    return {
      
    }
  },
  components:{
	PageTemplate
  }
}
</script>

<style scoped>
.gmapwrap{
	max-width:600px;
	width:100%;
	height:450px;
	max-height:100vw;
}
.gmapsize{
	border:0;
	width:100%;
	height:100%;
}
.lab-photo{
	max-width:100%;
	max-height:250px;
	padding:0 20px 0 20px;
	margin-bottom:-30px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactInfo.vue